import { Icon, IconSizeClasses, Tooltip } from '@eppendorf/vnls-react-components';

import { EventSeverityFilter } from '$features/report-hub/stability-report/severity-filter';
import { type EventCounts } from '$features/report-hub/stability-report/stability-report.types';

interface EventCountsRowProps {
  eventCounts: EventCounts | undefined;
  onEventTypeClick?: (severity: EventSeverityFilter) => void;
}

const EVENT_ITEMS = [
  { icon: 'event-error' as const, label: 'Error', severity: EventSeverityFilter.Error },
  { icon: 'event-alert' as const, label: 'Alert', severity: EventSeverityFilter.Alert },
  {
    icon: 'event-warning' as const,
    label: 'Warning',
    severity: EventSeverityFilter.Warning,
  },
  { icon: 'event-notice' as const, label: 'Info', severity: EventSeverityFilter.Info },
] as const;

export function EventCountsRow({ eventCounts, onEventTypeClick }: EventCountsRowProps) {
  const { errors = 0, alerts = 0, warnings = 0, infos = 0 } = eventCounts ?? {};
  const counts = { error: errors, alert: alerts, warning: warnings, info: infos };

  return (
    <div className="flex gap-l flex__jc--center">
      {EVENT_ITEMS.map((item) => (
        <span
          key={item.severity}
          role="button"
          tabIndex={-1}
          className="flex flex__ai--center gap-s"
          style={{ cursor: onEventTypeClick ? 'pointer' : 'default' }}
          onClick={() => onEventTypeClick?.(item.severity)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onEventTypeClick?.(item.severity);
            }
          }}
        >
          <Tooltip
            delayDuration={200}
            trigger={
              <span className="flex">
                <Icon name={item.icon} size={IconSizeClasses.XSmall} />
              </span>
            }
          >
            {item.label}
          </Tooltip>
          <span>{counts[item.severity as keyof typeof counts]}</span>
        </span>
      ))}
    </div>
  );
}
